<template>
  <div class="dashborad-embajador">
    <titulo-seccion titulo="DASHBOARD"> </titulo-seccion>
    <div class="container">
      <div>
        <DropDown
          placeholder="Selecciona una gráfica"
          :arreglo="graficas"
          llave="valor"
          valor="valor"
          texto="nombre"
          v-model="opcionGrafica"
          :requerido="false"
          :size="40"
          :nombre="'Selecciona una gráfica:'"
        ></DropDown>
      </div>
      <!-- Inicio filtros generales -->
      <div class="row row-cols-lg-12">
        <!-- Sucursal -->
        <div class="col-md-3" v-if="filtroGerenciaEsvisible">
          <div class="row" style="margin: 0 0 10px 60px">Sucursal</div>
          <DropDown
            :disabled="false"
            placeholder="Sucursal"
            :arreglo="sucursales"
            llave="proyectoVentaId"
            valor="proyectoVentaId"
            texto="nombre"
            v-model="sucursal"
          ></DropDown>
        </div>
        <!-- Embajador -->
        <div class="col-md-3" v-if="filtroEmbajadorEsvisible">
          <div class="row" style="margin: 0 0 10px 60px">Embajador</div>
          <DropDown
            placeholder="Selecciona un embajador"
            :arreglo="embajadores"
            llave="value"
            valor="value"
            texto="text"
            v-model="filtros.embajadorSeleccionado"
            :size="!filtroGerenciaEsvisible ? 90 : 45"
            :requerido="false"
            :nombre="'Perfil'"
          ></DropDown>
        </div>
        <!-- Fechas -->
        <div class="col-md-3" v-if="filtrosPeriodoSonVisibles">
          <div class="row" style="margin: 0 0 10px 60px">Fecha Inicial</div>
          <input-fecha
            :requerido="true"
            idioma="es-MX"
            v-model="fechaInicio"
            :fechaMinima="fechaPredeterminada"
          ></input-fecha>
        </div>
        <div class="col-md-3" v-if="filtrosPeriodoSonVisibles">
          <div class="row" style="margin: 0 0 10px 60px">Fecha Final</div>
          <input-fecha
            :requerido="true"
            idioma="es-MX"
            v-model="fechaFinal"
            :fechaMinima="fechaMinima"
          ></input-fecha>
        </div>
      </div>
      <!-- Inicio filtros generales -->
      <div class="dashboard-embajador__graficas" v-if="mostrarGrafica[0]">
        <div class="dashboard-embajador__grafica ga"></div>
        <div class="dashboard-embajador__grafica gb"></div>
        <div class="dashboard-embajador__grafica gc"></div>
      </div>
      <div
        class="dashboard-embajador__graficas--bar_gd"
        v-if="mostrarGrafica[1]"
      >
        <div class="grafica-actividad-personal"></div>
      </div>
      <div
        class="dashboard-embajador__graficas--bar_ge"
        v-if="mostrarGrafica[2]"
      >
        <div class="grafica-concentrado-final"></div>
      </div>
      <div
        class="dashboard-embajador__graficas--bar_gf"
        v-if="mostrarGrafica[3]"
      >
        <div class="row" style="width: 100.1%; margin: 0 0 0 1.5px">
          <div
            class="row"
            style="
              text-align: left;
              margin: 50px 0 -10px 0;
              padding: 0 0 0 10px;
            "
          >
            <p class="fw-bold" style="color: black">
              Concentrado final de operaciones por mes
            </p>
          </div>
          <div class="grafica-datos-operaciones"></div>
        </div>
      </div>
      <div
        class="dashboard-embajador__graficas--bar_gg"
        v-if="mostrarGrafica[4]"
      >
        <div class="grafica-datos-cartera"></div>
      </div>
      <div
        class="dashboard-embajador__graficas--bar_gh"
        v-if="mostrarGrafica[5]"
      >
        <div class="grafica-datos-ventas"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as echarts from "echarts";
import "../../../Componentes/TituloSeccion.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import DropDown from "../../Prospecto/components/DropDown.vue";
import servicios from "../../../servicios/service.js";
// import InputFecha from "../components/InputFecha.vue";
//RUTAS API
const apiBaseDashboard = "/api/Dashboard/Dashboard/";
const apiNumeroClientesPorEtapas =
  apiBaseDashboard + "ObtenerClientesEmbajador";
const apiNumeroClientesContratadosPorTipo =
  apiBaseDashboard + "ObtenerClientesContratadosPorTipoEmbajador";
const apiMontoOperacionesPorTipo =
  apiBaseDashboard + "ObtenerMontodeOperacionesEmbajador";
const apiReporteActividadesPorPersonal =
  apiBaseDashboard + "ObtenerReportedeActividadesPorPersonalMaster";
const apiConcentradoFinalOperaciones =
  apiBaseDashboard + "ObtenerConcentradoFinaldeOperacionesMaster";
const apiConcentradoFinalOperacionesporMes =
  apiBaseDashboard + "ObtenerConcentradoFinaldeOperacionesPorMesMaster";
const apiSeguimientoCarteraProspectosPausadaMaster =
  apiBaseDashboard + "ObtenerSeguimientoCarteraProspectosPausadaMaster";
const rutaListarEmbajadores = "/api/Master/Master/ListarEmbajadores";
const rutaListarProyectos = "/api/Master/Master/ListarProyectos";

//Variables para instancias de gráficas x)
var domNumeroClientes;
var graficaNumeroClientes;
var domClientesFirmados;
var graficaClientesFirmados;
var domMontoOperaciones;
var graficaMontoOperaciones;
// var domReporteActividades;
// var graficaReporteActividades;
var domConcentradoFinalOperaciones;
var graficaConcentradoFinalOperaciones;
var domDatosDeVentas;
var graficaDatosDeVentas;
var domDatosDeOperaciones;
var graficaDatosDeOperaciones;
var domDatosDeCartera;
var graficaDatosDeCartera;
var domActividadPersonal;
var graficaActividadPersonal;

//ESTILOS
const labelFormatNumeroClientes = {
  formatter: "{c}",
  position: "inside",
  fontSize: 16,
  fontWeight: "bold",
  color: "#ffffff",
};
const labelFormatTipoClientes = {
  show: true,
  fontSize: 14,
  fontWeight: "bold",
  color: "#ffffff",
};
const labelFormatMontoOperaciones = {
  show: true,
  formatter: function(valor) {
    return servicios.DarFormatoMoneda(valor.data);
  },
  fontSize: 14,
  fontWeight: "bold",
  color: "#ffffff",
};
// App Config para gráfica de reporte de actividades, concentrado final de operacions
var app = {};
app.config = {
  rotate: 90,
  align: "left",
  verticalAlign: "middle",
  position: "insideBottom",
  distance: 15,
};
const labelFormarReporteActividades = {
  show: true,
  formatter: "{c}",
  fontWeight: "bold",
  fontSize: 16,
  color: "white",
  position: app.config.position,
  distance: app.config.distance,
  align: "center",
  verticalAlign: "bottom",
  rotate: [30, 40],
};

const labelFormatDatosDeVentas = {
  show: true,
  formatter: "{c}",
  fontWeight: "bold",
  fontSize: 20,
  color: "white",
  align: "center",
  rotate: [30, 40],
};

var confirmado = {
  product: "Confirmado",
};

var pausado = {
  product: "Pausado",
};

var barras = [
  { type: "bar", color: "#d17963", barCategoryGap: "15%" },
  { type: "bar", color: "#AE745F" },
  { type: "bar", color: "#461D15" },
  { type: "bar", color: "#b3c2c9" },
  { type: "bar", color: "#323c80" },
  { type: "bar", color: "#141415" },
  { type: "bar", color: "#c69615" },
  { type: "bar", color: "#876200" },
  { type: "bar", color: "#5c4507" },
  // { type: "bar" },
  // { type: "bar" },
  // { type: "bar" },
];

var fecha = new Date(Date.now());
//var fechaActual = new Date(Date.now());
var motivos = [];
var embajadoresG2 = [];

var valoresActividadPersonales = [];

var resT = [];

// App
//ECHARTS
export default {
  name: "Dashboard",
  components: { TituloSeccion, DropDown },
  // components: { TituloSeccion, DropDown, InputFecha },
  async mounted() {
    this.embajadorId = this.$store.getters.masterId;
    this.tipoUsuario = this.$store.getters.tipoUsuario;

    this.mesesDelAnio = servicios
      .ObtenerMesesDelAnioParaDropDown()
      .slice(0, 12);

    this.opcionGrafica = 1;

    this.CargarGrafica();
  },
  computed: {
    opcionGraficaNumeroClientes() {
      return {
        color: ["#3B9C88", "#29294E", "#BD4F86"],
        textStyle: {
          fontFamily: "Poppins",
        },
        title: {
          text: "Número de clientes",
          left: "center",
          textStyle: {
            color: "black",
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "bottom",
          orient: "horizontal",
          left: "center",
          icon: "circle",
          textStyle: {
            color: "black",
          },
        },
        series: [
          {
            label: labelFormatNumeroClientes,
            type: "pie",
            radius: "70%",
            data: this.seedNumeroClientesEtapa,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
    // opcionGraficaReporteActividades() {
    //   return {
    //     tooltip: {
    //       trigger: "axis",
    //       axisPointer: {
    //         type: "shadow",
    //       },
    //     },
    //     grid: { bottom: 100 },
    //     xAxis: [
    //       {
    //         offset: 2,
    //         type: "category",
    //         interval: 0,
    //         axisLabel: {
    //           show: true,
    //           interval: 0,
    //           rotate: 90,
    //         },
    //         data: [
    //           "Contratado",
    //           "Descartado",
    //           "Pausado",
    //           "Contratado",
    //           "Descartado",
    //           "Pausado",
    //           "Contratado",
    //           "Descartado",
    //           "Pausado",
    //         ],
    //         axisTick: { show: false, interval: 1 },
    //       },
    //       {
    //         splitLine: {
    //           show: false,
    //         },
    //         type: "category",
    //         position: "bottom",
    //         axisLabel: {
    //           margin: 90,
    //           fontWeight: "bold",
    //           color: "black",
    //           interval: 0,
    //         },
    //         axisTick: { show: false },
    //         data: ["", "HIR 1", "", "", "HIR 2", "", "", "HIR 3", ""],
    //       },
    //     ],
    //     yAxis: [
    //       {
    //         type: "value",
    //         max: 10,
    //         show: false,
    //       },
    //     ],
    //     series: [
    //       {
    //         name: "Número de prospectos",
    //         type: "bar",
    //         barGap: 0,
    //         barWidth: 34,
    //         color: "#461D15",
    //         itemStyle: {
    //           borderRadius: [5, 5, 0, 0],
    //         },
    //         label: labelFormarReporteActividades,
    //         emphasis: {
    //           focus: "series",
    //         },
    //         data: [2, 5, 7, 8, 2, 5, 10, 11, 2],
    //       },
    //     ],
    //   };
    // },
    opcionGraficaNumeroClientesFirmadosTipo() {
      return {
        color: ["#29294E", "#3B599C", "#3F7797"],
        title: {
          text: "Tipos de Clientes Contratados",
          left: "center",
          textStyle: {
            color: "black",
          },
        },
        textStyle: {
          fontFamily: "Poppins",
        },
        legend: {
          top: "bottom",
          orient: "horizontal",
          left: "center",
          icon: "circle",
          textStyle: {
            color: "black",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        grid: {
          top: "30%",
          left: "3%",
          right: "4%",
          bottom: "30%",
          containLabel: false,
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
          data: ["Monto"],
        },
        series: this.seedTiposClientesFirmados,
      };
    },
    opcionGraficaMontoOperacionesTipo() {
      return {
        color: ["#3B9C88", "#29294E", "#BD4F86"],
        textStyle: {
          fontFamily: "Poppins",
        },
        title: {
          text: "Monto de las Operaciones",
          left: "center",
          textStyle: {
            color: "black",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: "bottom",
          orient: "horizontal",
          left: "center",
          icon: "circle",
          textStyle: {
            color: "black",
          },
        },
        grid: {
          top: "25%",
          left: "3%",
          right: "4%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          show: false,
          boundaryGap: [0, 0.01],
          max: this.valorMaximoEjeXMontoOperaciones,
        },
        yAxis: {
          show: false,
          data: ["Monto"],
        },
        series: this.seedMontoOperaciones,
      };
    },
    // Grafica 2
    opcionGraficaConcentradoFinalOperaciones() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: "bottom",
          orient: "horizontal",
          left: "center",
          icon: "circle",
          textStyle: {
            color: "black",
          },
        },
        xAxis: [
          {
            offset: 2,
            type: "category",
            interval: 0,
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 0,
            },
            data: ["Contratado", "Descartado", "Pausado"],
            axisTick: { show: false, interval: 1 },
          },
          {
            splitLine: {
              show: false,
            },
            type: "category",
            position: "bottom",
            axisLabel: {
              margin: 30,
              fontWeight: "bold",
              color: "black",
              interval: 0,
            },
            axisTick: { show: false },
            data: ["MTY"],
          },
        ],
        yAxis: [
          {
            type: "value",
            show: false,
          },
        ],
        series: [
          {
            name: "Suma estatus diario",
            type: "bar",
            color: "#3B9C88",
            barGap: 0,
            barWidth: 45,
            itemStyle: {
              borderRadius: [5, 5, 0, 0],
            },
            label: { show: false },
            emphasis: {
              focus: "series",
            },
            data: [320, 332, 301],
          },
          {
            name: "Suma de acumulado x periodo",
            type: "bar",
            color: "#BD4F86",
            barGap: 0,
            barWidth: 45,
            itemStyle: {
              borderRadius: [5, 5, 0, 0],
            },
            label: { show: false },
            emphasis: {
              focus: "series",
            },
            data: [220, 182, 191],
          },
        ],
      };
    },
    opcionGraficaActividadPersonal() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: { bottom: "35%" },
        xAxis: [
          {
            offset: 2,
            type: "category",
            interval: 0,
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 90,
            },
            data: motivos,
            axisTick: { show: false, interval: 1 },
          },
          {
            splitLine: {
              show: false,
            },
            type: "category",
            position: "bottom",
            axisLabel: {
              margin: 130,
              fontWeight: "bold",
              color: "black",
              interval: 0,
            },
            axisTick: { show: false },
            data: embajadoresG2,
          },
        ],
        yAxis: [
          {
            type: "value",
            max: 10,
            show: false,
          },
        ],
        series: [
          {
            name: "Número de prospectos",
            type: "bar",
            barGap: 0,
            barWidth: 34,
            color: "#461D15",
            itemStyle: {
              borderRadius: [5, 5, 0, 0],
            },
            label: labelFormarReporteActividades,
            emphasis: {
              focus: "series",
            },
            data: [5, 2, 1, 8, 2, 5, 10, 11, 2],
          },
        ],
      };
    },
    opcionGraficaDatosDeVentas() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: "bottom",
          orient: "horizontal",
          left: "right",
          icon: "circle",
          textStyle: {
            color: "black",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: false,
        },
        yAxis: {
          axisTick: { show: false },
          type: "category",
          data: ["Embajador 1", "Embajador 2", "Embajador 3"],
        },
        series: [
          {
            name: "Suma de ventas",
            type: "bar",
            stack: "total",
            color: "#3B9C88",
            barWidth: 40,
            label: labelFormatDatosDeVentas,
            emphasis: {
              focus: "series",
            },
            data: [320, 200, 110],
          },
          {
            name: "Suma de clientes",
            type: "bar",
            color: "#BD4F86",
            barWidth: 40,
            stack: "total",
            itemStyle: {
              borderRadius: [0, 5, 5, 0],
            },
            label: labelFormatDatosDeVentas,
            emphasis: {
              focus: "series",
            },
            data: [120, 200, 132],
          },
        ],
      };
    },
    opcionGraficaOperacionesporMes() {
      return {
        legend: {
          top: "95%",
          orient: "horizontal",
          icon: "circle",
        },
        tooltip: {},
        dataset: {
          source: [confirmado, pausado],
        },
        xAxis: {
          type: "category",
          axisLine: { show: false },
          axisTick: { show: false },
        },
        yAxis: { show: false },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: this.mostrarBarras,
      };
    },
    opcionGraficaCarteraProspectosPausada() {
      return {
        legend: { orient: "horizontal", icon: "circle" },
        tooltip: {},
        xAxis: [
          {
            offset: 2,
            type: "category",
            interval: 0,
            axisLabel: {
              show: true,
              interval: 0,
            },
            axisLine: { show: true },
            data: [
              "AGS",
              "MTY",
              "TJN",
              "AGS",
              "MTY",
              "TJN",
              "AGS",
              "MTY",
              "TJN",
            ],
            axisTick: { show: false, interval: 1 },
          },
          {
            splitLine: {
              show: false,
            },
            type: "category",
            position: "bottom",
            axisLabel: {
              margin: 40,
              fontWeight: "bold",
              color: "black",
              interval: 0,
            },
            axisTick: { show: false },
            data: [
              "",
              "Desinteresado por el momento",
              "",
              "",
              "Falta de documentos",
              "",
              "",
              "Aún no paga cuota de ins",
              "",
            ],
          },
        ],
        yAxis: [{ show: false }],
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: "bar",
            color: "#3B9C88",
            name: "Suma de Estatus Diario",
            emphasis: {
              focus: "series",
            },
            data: [25, 42, 15, 25, 25, 25, 41, 75, 96],
          },
          {
            type: "bar",
            color: "#29294E",
            name: "Suma de Acumulado por Periodo",
            emphasis: {
              focus: "series",
            },
            data: [15, 22, 35, 85, 45, 5, 91, 25, 36],
          },
        ],
      };
    },
  },
  data() {
    return {
      embajadorId: null,
      proyectoId: null,
      numeroDeClientesPorEtapas: null,
      modeloTest: 0,
      modeloTestB: 1,
      embajadores: [],
      proyectos: [],
      mesesDelAnio: [],
      graficas: [
        { nombre: "Gráfica de Reporte General", valor: 1 },
        { nombre: "Gráfica de Reporte de Actividades por Personal", valor: 2 },
        {
          nombre: "Gráfica de Reporte Concentrado Final de Operaciones",
          valor: 3,
        },
        {
          nombre: "Gráfica de Reporte Concentrado Final de Operaciones por Mes",
          valor: 4,
        },
        {
          nombre:
            "Gráfica de Reporte Seguimiento a la Cartera de Prospectos Pausada",
          valor: 5,
        },
        {
          nombre: "Gráfica de Reporte de Ventas",
          valor: 6,
        },
      ],
      opcionGrafica: 1,
      //FILTROS
      filtros: {
        mesInicial: 1,
        mesFinal: 12,
        fecha: new Date(Date.now()).toISOString(),
        //fechaActual: new Date(Date.now()).toISOString(),
        fechaInicio: new Date(Date.now()).toISOString(),
        fechaFinal: new Date(Date.now()).toISOString(),
        fechaPredeterminada: new Date(Date.now()).toISOString(),
        embajadorSeleccionado: null,
        proyectoSeleccionado: null,
      },
      //Visibilidad de gráficas
      graficaBarraMasterEsVisible: false,
      //Visibilidad de filtros
      filtroEmbajadorEsvisible: false,
      filtroGerenciaEsvisible: false,
      filtrosPeriodoSonVisibles: false,
      //Seed de las grácias
      seedNumeroClientesEtapa: [
        { value: null, name: "Contratados" },
        { value: null, name: "Pausados" },
        { value: null, name: "Prospectos" },
      ],
      seedTiposClientesFirmados: [
        {
          name: "Persona moral",
          type: "bar",
          stack: "total",
          label: labelFormatTipoClientes,
          emphasis: {
            focus: "series",
          },
          data: null,
        },
        {
          name: "Persona física",
          type: "bar",
          stack: "total",
          label: labelFormatTipoClientes,
          emphasis: {
            focus: "series",
          },
          data: null,
        },
        {
          name: "Extranjeros",
          type: "bar",
          stack: "total",
          label: labelFormatTipoClientes,
          emphasis: {
            focus: "series",
          },
          data: null,
        },
      ],
      valorMaximoEjeXMontoOperaciones: 50000,
      seedMontoOperaciones: [
        {
          label: labelFormatMontoOperaciones,
          barMinWidth: "35",
          name: "Contratados",
          type: "bar",
          data: null,
        },
        {
          label: labelFormatMontoOperaciones,
          barMinWidth: "35",
          barGap: "0",
          name: "Pausados",
          type: "bar",
          data: null,
        },
        {
          label: labelFormatMontoOperaciones,
          barMinWidth: "35",
          name: "Prospectos",
          type: "bar",
          data: null,
        },
      ],
      sucursales: [],
      sucursal: "1",
      mostrarBarras: [],
      calculoMeses: [
        {
          texto:
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 3,
              1
            ).toLocaleString("es-MX", { month: "long" }) +
            " - " +
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 3,
              1
            ).getFullYear(),
          fecha: new Date(fecha.getFullYear(), fecha.getMonth() - 3, 1),
          valor: 1,
        },
        {
          texto:
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 2,
              1
            ).toLocaleString("es-MX", { month: "long" }) +
            " - " +
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 2,
              1
            ).getFullYear(),
          fecha: new Date(fecha.getFullYear(), fecha.getMonth() - 2, 1),
          valor: 2,
        },
        {
          texto:
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 1,
              1
            ).toLocaleString("es-MX", { month: "long" }) +
            " - " +
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 1,
              1
            ).getFullYear(),
          fecha: new Date(fecha.getFullYear(), fecha.getMonth() - 1, 1),
          valor: 3,
        },
      ],
      calculoMesesFinales: [
        {
          texto:
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 1,
              1
            ).toLocaleString("es-MX", { month: "long" }) +
            " - " +
            new Date(
              fecha.getFullYear(),
              fecha.getMonth() - 1,
              1
            ).getFullYear(),
          fecha: new Date(fecha.getFullYear(), fecha.getMonth() - 1, 1),
          valor: 1,
        },
        {
          texto:
            new Date(
              fecha.getFullYear(),
              fecha.getMonth(),
              1
            ).toLocaleString("es-MX", { month: "long" }) +
            " - " +
            new Date(fecha.getFullYear(), fecha.getMonth(), 1).getFullYear(),
          fecha: new Date(fecha.getFullYear(), fecha.getMonth(), 1),
          valor: 2,
        },
      ],
      fechaActual: 2,
      fechaFinal: 1,
      mostrarGrafica: [true, false, false, false, false, false],
    };
  },
  watch: {
    "filtros.embajadorSeleccionado": async function(value) {
      await this.ObtenerNumeroClientesPorEtapasEmbajador(value);
      await this.ObtenerNumeroClientesContratadosPorTipoEmbajador(value);
      await this.ObtenerMontodeOperacionesPorTipoEmbajador(value);
      await this.ObtenerReportedeActividades(
        this.filtros.proyectoSeleccionado,
        value
      );
      await this.ObtenerConcentradoFinalOperaciones(
        this.filtros.proyectoSeleccionado,
        value
      );
    },
    "filtros.proyectoSeleccionado": async function(value) {
      await this.ListarEmbajadores(false, value);
    },
    sucursal: async function() {
      confirmado = { product: "Confirmado" };
      pausado = { product: "Pausado" };
      await this.ObtenerConcentradoFinaldeOperacionesPorMes();
      graficaDatosDeOperaciones.setOption(this.opcionGraficaOperacionesporMes);
      graficaDatosDeOperaciones.resize();
    },
    // fechaActual: async function (value) {
    //   this.calculoMesesFinales = [];
    //   let fechaValor = this.calculoMeses[value - 1].fecha;
    //   let fechaActual = new Date(fecha.getFullYear(), fecha.getMonth(), 1);
    //   let fechaObjetivo = new Date(
    //     fechaValor.getFullYear(),
    //     fechaValor.getMonth(),
    //     1
    //   );

    //   let x = 1;

    //   while (fechaActual.toString() != fechaObjetivo.toString()) {
    //     fechaObjetivo = new Date(
    //       fechaValor.getFullYear(),
    //       fechaValor.getMonth() + x,
    //       1
    //     );
    //     let objetoFecha = {
    //       texto:
    //         new Date(
    //           fechaObjetivo.getFullYear(),
    //           fechaObjetivo.getMonth(),
    //           1
    //         ).toLocaleString("es-MX", { month: "long" }) +
    //         " - " +
    //         new Date(
    //           fechaObjetivo.getFullYear(),
    //           fechaObjetivo.getMonth(),
    //           1
    //         ).getFullYear(),
    //       fecha: new Date(
    //         fechaObjetivo.getFullYear(),
    //         fechaObjetivo.getMonth(),
    //         1
    //       ),
    //       valor: x,
    //     };
    //     this.calculoMesesFinales.push(objetoFecha);
    //     x++;
    //   }

    //   await this.ObtenerConcentradoFinaldeOperacionesPorMes();
    //   graficaDatosDeOperaciones.setOption(this.opcionGraficaOperacionesporMes);
    //   graficaDatosDeOperaciones.resize();
    // },
    fechaFinal: async function() {
      await this.ObtenerConcentradoFinaldeOperacionesPorMes();
      graficaDatosDeOperaciones.setOption(this.opcionGraficaOperacionesporMes);
      graficaDatosDeOperaciones.resize();
    },
    opcionGrafica: async function(value) {
      this.mostrarGrafica[0] = false;
      this.mostrarGrafica[1] = false;
      this.mostrarGrafica[2] = false;
      this.mostrarGrafica[3] = false;
      this.mostrarGrafica[4] = false;
      this.mostrarGrafica[5] = false;

      this.opcionGrafica = value;
      this.mostrarGrafica[value - 1] = true;
      await this.ReiniciarGraficas();
      this.CargarGrafica();
    },
  },
  methods: {
    async CargarGrafica() {
      await this.ReiniciarGraficas();
      await this.MostrarGraficas(this.tipoUsuario);
      switch (this.opcionGrafica) {
        case 2:
          await this.ObtenerReporteActividadesPersonal();
          await this.GenerarActividadPorPersonal();
          graficaActividadPersonal.resize();
          break;
        case 3:
          await this.GenerarGraficaConcentradoFinalOperaciones();
          graficaConcentradoFinalOperaciones.resize();
          break;
        case 4:
          await this.GenerarGraficaOperacionesporMes();
          await this.ListarSucursales();
          await this.ObtenerConcentradoFinaldeOperacionesPorMes();
          graficaDatosDeOperaciones.resize();
          break;
        case 5:
          await this.GenerarGraficaCarteraProspectosPausada();
          graficaDatosDeCartera.resize();
          break;
        case 6:
          await this.GenerarGraficaDatosDeVentas();
          graficaDatosDeVentas.resize();
          await this.ObtenerSeguimientoCarteraProspectosPausadaMaster();
          break;
      }
    },
    async ReiniciarGraficas() {
      if (
        graficaNumeroClientes != null &&
        graficaNumeroClientes != "" &&
        graficaNumeroClientes != undefined
      )
        graficaNumeroClientes.dispose();

      if (
        graficaClientesFirmados != null &&
        graficaClientesFirmados != "" &&
        graficaClientesFirmados != undefined
      )
        graficaClientesFirmados.dispose();

      if (
        graficaMontoOperaciones != null &&
        graficaMontoOperaciones != "" &&
        graficaMontoOperaciones != undefined
      )
        graficaMontoOperaciones.dispose();

      if (
        graficaActividadPersonal != null &&
        graficaActividadPersonal != "" &&
        graficaActividadPersonal != undefined
      )
        graficaActividadPersonal.dispose();

      if (
        graficaConcentradoFinalOperaciones != null &&
        graficaConcentradoFinalOperaciones != "" &&
        graficaConcentradoFinalOperaciones != undefined
      )
        graficaConcentradoFinalOperaciones.dispose();

      if (
        graficaDatosDeOperaciones != null &&
        graficaDatosDeOperaciones != "" &&
        graficaDatosDeOperaciones != undefined
      )
        graficaDatosDeOperaciones.dispose();

      if (
        graficaDatosDeVentas != null &&
        graficaDatosDeVentas != "" &&
        graficaDatosDeVentas != undefined
      )
        graficaDatosDeVentas.dispose();

      if (
        graficaDatosDeCartera != null &&
        graficaDatosDeCartera != "" &&
        graficaDatosDeCartera != undefined
      )
        graficaDatosDeCartera.dispose();
    },
    async ObtenerNumeroClientesPorEtapasEmbajador(embajadorId) {
      const embajador = { params: { masterId: embajadorId } };
      try {
        let info = await axios.get(apiNumeroClientesPorEtapas, embajador);
        if (info.data.estado == 0) {
          this.seedNumeroClientesEtapa[0].value = info.data.data.contratados;
          this.seedNumeroClientesEtapa[1].value = info.data.data.pausados;
          this.seedNumeroClientesEtapa[2].value = info.data.data.prospectos;

          domNumeroClientes = document.querySelector(
            ".dashboard-embajador__grafica.ga"
          );
          graficaNumeroClientes = echarts.init(domNumeroClientes);
          graficaNumeroClientes.setOption(this.opcionGraficaNumeroClientes);
        }
      } catch (err) {
        this.ManejarExcepcion(err);
      }
    },
    async ObtenerNumeroClientesContratadosPorTipoEmbajador(embajadorId) {
      const embajador = { params: { masterId: embajadorId } };
      try {
        let info = await axios.get(
          apiNumeroClientesContratadosPorTipo,
          embajador
        );
        if (info.data.estado == 0) {
          this.seedTiposClientesFirmados[0].data = [
            info.data.data.personaMoral,
          ];
          this.seedTiposClientesFirmados[1].data = [
            info.data.data.personaFisica,
          ];
          this.seedTiposClientesFirmados[2].data = [info.data.data.extranjero];

          domClientesFirmados = document.querySelector(
            ".dashboard-embajador__grafica.gb"
          );
          graficaClientesFirmados = echarts.init(domClientesFirmados);
          graficaClientesFirmados.setOption(
            this.opcionGraficaNumeroClientesFirmadosTipo
          );
        }
      } catch (err) {
        this.ManejarExcepcion(err);
      }
    },
    async ObtenerMontodeOperacionesPorTipoEmbajador(embajadorId) {
      const embajador = { params: { masterId: embajadorId } };
      try {
        let info = await axios.get(apiMontoOperacionesPorTipo, embajador);
        if (info.data.estado == 0) {
          this.seedMontoOperaciones[0].data = [info.data.data.montoContratados];
          this.seedMontoOperaciones[1].data = [info.data.data.montoPausados];
          this.seedMontoOperaciones[2].data = [info.data.data.montoProspectos];
          this.valorMaximoEjeXMontoOperaciones = Math.max(
            ...this.seedMontoOperaciones.map((s) => s.data)
          );
          domMontoOperaciones = document.querySelector(
            ".dashboard-embajador__grafica.gc"
          );
          graficaMontoOperaciones = echarts.init(domMontoOperaciones);
          graficaMontoOperaciones.setOption(
            this.opcionGraficaMontoOperacionesTipo
          );
        }
      } catch (err) {
        this.ManejarExcepcion(err);
      }
    },
    async ObtenerReportedeActividades(proyectoId, embajadorId = 0) {
      const parametros = {
        params: { proyectoId: proyectoId, embajadorId: embajadorId },
      };
      await axios.get(apiReporteActividadesPorPersonal, parametros);
    },
    async ObtenerConcentradoFinalOperaciones(proyectoId, embajadorId) {
      const parametros = {
        params: { proyectoId: proyectoId, embajadorId: embajadorId },
      };
      await axios.get(apiConcentradoFinalOperaciones, parametros);
    },
    // async GenerarGraficaCF() {
    //   domReporteActividades = document.querySelector(
    //     ".grafica-reporte-actividades"
    //   );
    //   graficaReporteActividades = echarts.init(domReporteActividades);
    //   graficaReporteActividades.setOption(this.opcionGraficaReporteActividades);
    // },
    async GenerarGraficaConcentradoFinalOperaciones() {
      domConcentradoFinalOperaciones = document.querySelector(
        ".grafica-concentrado-final"
      );
      graficaConcentradoFinalOperaciones = echarts.init(
        domConcentradoFinalOperaciones
      );
      graficaConcentradoFinalOperaciones.setOption(
        this.opcionGraficaConcentradoFinalOperaciones
      );
    },
    async GenerarGraficaDatosDeVentas() {
      domDatosDeVentas = document.querySelector(".grafica-datos-ventas");
      graficaDatosDeVentas = echarts.init(domDatosDeVentas);
      graficaDatosDeVentas.setOption(this.opcionGraficaDatosDeVentas);
    },
    async GenerarGraficaOperacionesporMes() {
      domDatosDeOperaciones = document.querySelector(
        ".grafica-datos-operaciones"
      );
      graficaDatosDeOperaciones = echarts.init(domDatosDeOperaciones);
      graficaDatosDeOperaciones.setOption(this.opcionGraficaOperacionesporMes);
    },
    async GenerarActividadPorPersonal() {
      domActividadPersonal = document.querySelector(
        ".grafica-actividad-personal"
      );
      graficaActividadPersonal = echarts.init(domActividadPersonal);
      graficaActividadPersonal.setOption(this.opcionGraficaActividadPersonal);
    },
    async GenerarGraficaCarteraProspectosPausada() {
      domDatosDeCartera = document.querySelector(".grafica-datos-cartera");
      graficaDatosDeCartera = echarts.init(domDatosDeCartera);
      graficaDatosDeCartera.setOption(
        this.opcionGraficaCarteraProspectosPausada
      );
    },
    async MostrarGraficas(perfil) {
      switch (perfil) {
        case 1:
          this.filtroEmbajadorEsvisible = false;
          this.filtroGerenciaEsvisible = false;
          this.filtrosPeriodoSonVisibles = true;
          await this.ObtenerNumeroClientesPorEtapasEmbajador(this.embajadorId);
          await this.ObtenerNumeroClientesContratadosPorTipoEmbajador(
            this.embajadorId
          );
          await this.ObtenerMontodeOperacionesPorTipoEmbajador(
            this.embajadorId
          );
          break;
        case 6:
          this.filtroEmbajadorEsvisible = true;
          this.filtroGerenciaEsvisible = true;
          this.filtrosPeriodoSonVisibles = true;
          this.ListarEmbajadores(true);
          break;
        case 7:
          this.filtroEmbajadorEsvisible = true;
          this.filtroGerenciaEsvisible = true;
          this.filtrosPeriodoSonVisibles = true;
          console.log("Master comercial"); //Pendiente de implementación, por eso se aplica el console.
          break;
        case 8:
          this.ListarProyectos();
          this.filtrosPeriodoSonVisibles = true;
          this.filtroGerenciaEsvisible = true;
          this.filtroEmbajadorEsvisible = true;
          this.graficaBarraMasterEsVisible = true;
          break;
      }
    },
    ListarProyectos() {
      const conEmbajadores = { params: { conEmbajadoresExistentes: true } };
      axios
        .get(rutaListarProyectos, conEmbajadores)
        .then((res) => {
          if (res.data.estado === 0) {
            var arregloProyectos = res.data.data;
            arregloProyectos.forEach((p) =>
              this.proyectos.push({ text: p.nombre, value: p.proyectoVentaId })
            );
            this.filtros.proyectoSeleccionado = this.proyectos[0].value;
          }
        })
        .catch((e) => this.ManejarExcepcion(e));
    },
    ListarEmbajadores(esGerente, proyectoId = 0) {
      const EsGerente = {
        params: {
          esGerente: esGerente,
          proyectoId: proyectoId,
        },
      };
      axios
        .get(rutaListarEmbajadores, EsGerente)
        .then((res) => {
          if (res.data.estado === 0) {
            this.embajadores = [];
            let arregloEmbajadores = res.data.data;
            arregloEmbajadores.forEach((e) =>
              this.embajadores.push({
                text: e.nombres + " " + e.apellidoPaterno,
                value: e.masterId,
              })
            );
            this.filtros.embajadorSeleccionado = this.embajadores[0].value;
          }
        })
        .catch((e) => this.ManejarExcepcion(e));
    },
    async ListarSucursales() {
      const conEmbajadores = { params: { conEmbajadoresExistentes: false } };
      try {
        let res = await axios.get(rutaListarProyectos, conEmbajadores);

        this.sucursales = res.data.data;
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async ObtenerConcentradoFinaldeOperacionesPorMes() {
      const parametros = {
        params: {
          proyectoId: this.sucursal,
          embajadorId: this.embajadorId,
          fechaInicio: new Date(this.calculoMeses[this.fechaActual - 1].fecha),
          fechaTermino: new Date(
            this.calculoMesesFinales[this.fechaFinal - 1].fecha
          ),
        },
      };
      let datosConfirmados = new Object();
      let datosPausados = new Object();
      try {
        let datos = (
          await axios.get(apiConcentradoFinalOperacionesporMes, parametros)
        ).data.data;

        let y = 0;
        this.mostrarBarras = [];

        datos.forEach((x) => {
          datosConfirmados[x.mes] = x.confirmados;
          datosPausados[x.mes] = x.pausados;

          this.mostrarBarras.push(barras[y]);
          y += 1;
        });

        confirmado = Object.assign(confirmado, datosConfirmados);
        pausado = Object.assign(pausado, datosPausados);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async ObtenerSeguimientoCarteraProspectosPausadaMaster() {
      const parametros = {
        params: {
          proyectoId: this.sucursal,
          embajadorId: this.embajadorId,
          motivoId: 0,
        },
      };

      try {
        let datos = (
          await axios.get(
            apiSeguimientoCarteraProspectosPausadaMaster,
            parametros
          )
        ).data.data;
        console.log(datos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async ObtenerReporteActividadesPersonal() {
      let proyecto = this.proyectoId;
      embajadoresG2 = [];
      motivos = [];

      if (this.tipoUsuario == 1) {
        proyecto = 0;
      }

      const parametros = {
        params: {
          proyectoId: proyecto,
          embajadorId: this.embajadorId,
        },
      };

      try {
        resT = (await axios.get(apiReporteActividadesPorPersonal, parametros))
          .data.data;

        resT.forEach((x) => {
          embajadoresG2.push("");
          embajadoresG2.push(x.nombreMaster);
          embajadoresG2.push("");
          motivos.push(x.nombreEtapa);
          valoresActividadPersonales.push(x.pausados);
        });
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/estilos/estilosgenerales.scss";

.dashborad-embajador {
  flex-grow: 1;
}
.dashboard-embajador__contenedor--filtros {
  width: 96.7%;
  display: flex;
  justify-content: space-between;
  margin: 40px 0 30px 0;
}
.dashboard-embajador__filtro--A {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.dashboard-embajador__filtro--B {
  @extend .dashboard-embajador__filtro--A;
  justify-content: flex-end;
}
.dashboard-embajador__graficas {
  margin: 20px 0 0 0;
  grid-gap: 10px;
  display: grid;
  grid-template-columns: 30% 20% 45%;
  grid-template-rows: 200px 200px;
}
.dashboard-embajador__grafica {
  border: 2px solid #cbcbcb;
  padding: 10px;
}
.ga {
  grid-column: 1 / 3;
  grid-row: 1/3;
}
.gb {
  grid-column: 3 / 3;
  grid-row: 1;
}
.gc {
  grid-column: 3/3;
  grid-row: 2;
}

.dashboard-embajador__graficas--bar {
  margin-top: 20px;
  width: 96.7%;
  height: 550px;
  border: 2px solid #cbcbcb;
}
.dashboard-embajador__graficas--bar_gd .grafica-actividad-personal {
  margin-top: 20px;
  width: 96.7%;
  height: 550px;
  border: 2px solid #cbcbcb;
}
.dashboard-embajador__graficas--bar_gf .grafica-datos-operaciones {
  margin-top: 20px;
  width: 96.7%;
  height: 550px;
  border: 2px solid #cbcbcb;
}
.dashboard-embajador__graficas--bar_ge .grafica-concentrado-final {
  margin-top: 20px;
  width: 96.7%;
  height: 550px;
  border: 2px solid #cbcbcb;
}
.dashboard-embajador__graficas--bar_gg .grafica-datos-cartera {
  margin-top: 20px;
  width: 76.7%;
  height: 550px;
  border: 2px solid #cbcbcb;
  margin: 20px auto 0 auto;
}
.dashboard-embajador__graficas--bar_gh .grafica-datos-ventas {
  margin-top: 20px;
  width: 76.7%;
  height: 550px;
  border: 2px solid #cbcbcb;
  margin: 20px auto 0 auto;
}
</style>
